<div class="ticket-queue-container">
  <div class="queue-error" *ngIf="errorMessage">
    <i class="fa-solid fa-triangle-exclamation"></i> {{ errorMessage }}
  </div>

  <!-- Quick filters + search -->
  <div class="queue-controls">
    <div class="quick-filters">
      <button class="quick-filter" [class.active]="filterReady && quickFilter === 'all' && !assigneeFilter" (click)="setQuickFilter('all')">All</button>
      <button class="quick-filter" [class.active]="filterReady && quickFilter === 'open' && !assigneeFilter" (click)="setQuickFilter('open')">Open</button>
      <button class="quick-filter" [class.active]="filterReady && ((quickFilter === 'unassigned' && !assigneeFilter) || assigneeFilter === 'unassigned')" (click)="setQuickFilter('unassigned')">Unassigned</button>
      <button class="quick-filter" [class.active]="filterReady && quickFilter === 'resolved' && !assigneeFilter" (click)="setQuickFilter('resolved')">Resolved</button>
      <!-- Escalated tickets need eyes — the chip only appears when there ARE some, with a count. -->
      <button class="quick-filter quick-filter-escalated" *ngIf="escalatedCount > 0"
              [class.active]="filterReady && quickFilter === 'escalated' && !assigneeFilter"
              (click)="setQuickFilter('escalated')"
              title="Tickets with an escalated message awaiting human review">
        <i class="fa-solid fa-triangle-exclamation"></i> Escalated
        <span class="escalated-count">{{ escalatedCount }}</span>
      </button>

      <!-- Assignee filter (mirrors the message queue): Mine + by-person dropdown.
           The current user is excluded from the dropdown — "Mine" covers them. -->
      <button class="quick-filter" *ngIf="currentPersonId"
              [class.active]="filterReady && isMineActive" (click)="setMine()"
              title="Show tickets assigned to me">Mine</button>
      <div class="assignee-filter-dropdown" *ngIf="orgTeamMembers.length > 0">
        <select class="filter-select"
                [ngModel]="isMineActive ? '' : (assigneeFilter === 'unassigned' ? '' : (assigneeFilter || ''))"
                (ngModelChange)="filterByAssignee($event)">
          <option value="">By person…</option>
          <option *ngFor="let member of orgTeamMembers" [value]="member.personId">{{ member.name }}</option>
        </select>
      </div>
    </div>
    <div class="queue-search">
      <i class="fa-solid fa-search"></i>
      <input type="text" placeholder="Search tickets…" [(ngModel)]="searchQuery" />
      <select [(ngModel)]="statusFilterId" class="filter-select">
        <option value="">All statuses</option>
        <option *ngFor="let s of statuses" [value]="s.ID">{{ s.Name }}</option>
      </select>
      <select [(ngModel)]="priorityFilter" class="filter-select">
        <option value="">All priorities</option>
        <option value="Critical">Critical</option>
        <option value="High">High</option>
        <option value="Medium">Medium</option>
        <option value="Low">Low</option>
      </select>
    </div>
  </div>

  <!-- Scrollable content area (card on a soft page background — Izzy theme) -->
  <div class="queue-content">
    <!-- Loading -->
    <div class="queue-loading" *ngIf="isLoading">
      <i class="fa-solid fa-spinner fa-spin"></i> Loading tickets…
    </div>

    <!-- Empty -->
    <div class="queue-empty" *ngIf="!isLoading && filteredTickets.length === 0">
      <i class="fa-solid fa-inbox"></i>
      <p>No tickets{{ tickets.length > 0 ? ' match the current filters' : ' yet' }}.</p>
    </div>

    <!-- Ticket list card -->
    <div class="queue-card" *ngIf="!isLoading && filteredTickets.length > 0">
      <div class="queue-card-header">
        <h3><i class="fa-solid fa-ticket"></i> Tickets</h3>
        <div class="queue-card-meta">
          <span class="ticket-count">{{ filteredTickets.length }} of {{ tickets.length }}</span>
          <button class="queue-refresh" (click)="loadData()" [disabled]="isLoading" title="Refresh">
            <i class="fa-solid fa-refresh" [class.fa-spin]="isLoading"></i>
          </button>
        </div>
      </div>

      <div class="queue-table">
        <div class="queue-row queue-row-header">
          <span class="col-number">Ticket</span>
          <span class="col-subject">Subject</span>
          <span class="col-reporter">Reporter</span>
          <span class="col-type">Type</span>
          <span class="col-status">Status</span>
          <span class="col-priority">Priority</span>
          <span class="col-sla">SLA</span>
          <span class="col-assignee">Assignee</span>
        </div>

        <div class="queue-row" *ngFor="let t of filteredTickets" (click)="open(t)" tabindex="0" [class.row-escalated]="t.escalated">
          <span class="col-number">{{ t.ticketLabel }}</span>
          <span class="col-subject" [title]="t.issue.Title">
            <span class="row-escalated-chip" *ngIf="t.escalated" title="Escalated — awaiting human review">
              <i class="fa-solid fa-triangle-exclamation"></i> Escalated
            </span>
            {{ t.issue.Title }}
          </span>
          <span class="col-reporter" [title]="t.issue.ReporterEmail || ''">{{ getReporterLabel(t) }}</span>
          <span class="col-type">{{ t.type?.Name || t.issue.IssueType || '—' }}</span>
          <span class="col-status">
            <span class="status-chip" [style.background]="getStatusColor(t)">{{ t.status?.Name || t.issue.Status || 'Unknown' }}</span>
          </span>
          <span class="col-priority">
            <span class="priority-dot" [ngClass]="getPriorityClass(t)" [title]="t.issue.Priority"></span>
            {{ t.issue.Priority }}
          </span>
          <span class="col-sla">
            <span class="sla-badge" [ngClass]="'sla-' + t.sla.kind" *ngIf="t.sla.kind !== 'none'">{{ t.sla.label }}</span>
            <span class="sla-none" *ngIf="t.sla.kind === 'none'">—</span>
          </span>
          <span class="col-assignee">{{ getAssigneeLabel(t) }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
